import type { RoomState } from '../../shared/types.js';

export type ClientState = (RoomState & { youId: string }) | null;

const SESSION_KEY = 'tubr.sessionId';
const NAME_KEY = 'tubr.name';
const PRESET_KEY = 'tubr.preset';

export function getOrCreateSessionId(): string {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID().replace(/-/g, '');
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

export function getStoredName(): string | undefined {
  return localStorage.getItem(NAME_KEY) ?? undefined;
}

export function setStoredName(name: string): void {
  localStorage.setItem(NAME_KEY, name);
}

export function getPreset(): string[] {
  try {
    const raw = localStorage.getItem(PRESET_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function setPreset(gameIds: string[]): void {
  localStorage.setItem(PRESET_KEY, JSON.stringify(gameIds));
}
